import React, { useRef, useState } from "react";
import { sendNewsletterEmail, validateFormData } from "../utils/emailService";
import Images from "../assets/AllImages";
import { useTranslation } from "react-i18next";
import { useToast } from "./Toast";

const Form = () => {
  const { t } = useTranslation();
  const { success, error } = useToast();
  const form = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

const sendEmail = async (e) => {
  e.preventDefault();
  if (isSubmitting) return;
  if (!form.current) return;

  setIsSubmitting(true);

  const fd = new FormData(form.current);

  // honeypot
  if (fd.get("website")) {
    setIsSubmitting(false);
    return;
  }

  const data = {
    user_name:    String(fd.get("user_name")    || "").trim(),
    user_surname: String(fd.get("user_surname") || "").trim(),
    user_email:   String(fd.get("user_email")   || "").trim(),
  };

  const { isValid, errors } = validateFormData("newsletter", data);
  if (!isValid) {
    // errors are already human-readable; no translation mapping
    error((t("newsletter.fixErrors") || "Please fix the errors:") + "\n" + errors.join("\n"));
    setIsSubmitting(false);
    return;
  }

  try {
    await sendNewsletterEmail(data); // throws on failure
    success(t("newsletter.success") || "Subscribed successfully.");
    form.current.reset();
  } catch (err) {
    error(
      (t("newsletter.failurePrefix") || "Subscription failed:") +
        " " +
        (err?.message || t("newsletter.unknownError") || "Please try again.")
    );
    console.error("Newsletter form error:", err);
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <section className="container-fluid bg-primary py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6 mb-4 mb-md-0">
            <div className="form-img text-center">
              <img
                src={Images.FormImg}
                alt={t("newsletter.altImage")}
                className="img-fluid"
                style={{ maxWidth: "80%" }}
              />
            </div>
          </div>

          <div className="col-lg-7 col-md-6 text-white">
            <div className="newsletter-content">
              <h2
                className="fw-bold mb-4"
                style={{ fontSize: "2.5rem", lineHeight: "1.2" }}
              >
                {t("newsletter.title")}
              </h2>

              <p
                className="mb-4"
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.6",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                {t("newsletter.subtitle")}
              </p>

              <form ref={form} onSubmit={sendEmail} noValidate>
                <fieldset
                  disabled={isSubmitting}
                  style={{ border: 0, padding: 0, margin: 0 }}
                >
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label htmlFor="user_name" className="visually-hidden">
                        {t("newsletter.firstName")}
                      </label>
                      <input
                        id="user_name"
                        type="text"
                        name="user_name"
                        placeholder={t("newsletter.firstName")}
                        className="form-control form-control-lg"
                        autoComplete="given-name"
                        required
                        style={{
                          borderRadius: "0px",
                          border: "none",
                          padding: "1rem 1.2rem",
                          fontSize: "1rem",
                          backgroundColor: "#fff",
                          color: "#333",
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="user_surname" className="visually-hidden">
                        {t("newsletter.lastName")}
                      </label>
                      <input
                        id="user_surname"
                        type="text"
                        name="user_surname"
                        placeholder={t("newsletter.lastName")}
                        className="form-control form-control-lg"
                        autoComplete="family-name"
                        required
                        style={{
                          borderRadius: "0px",
                          border: "none",
                          padding: "1rem 1.2rem",
                          fontSize: "1rem",
                          backgroundColor: "#fff",
                          color: "#333",
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="user_email" className="visually-hidden">
                        {t("newsletter.email")}
                      </label>
                      <input
                        id="user_email"
                        type="email"
                        name="user_email"
                        placeholder={t("newsletter.email")}
                        className="form-control form-control-lg"
                        autoComplete="email"
                        inputMode="email"
                        required
                        style={{
                          borderRadius: "0px",
                          border: "none",
                          padding: "1rem 1.2rem",
                          fontSize: "1rem",
                          backgroundColor: "#fff",
                          color: "#333",
                        }}
                      />
                    </div>

                    {/* honeypot */}
                    <input
                      type="text"
                      name="website"
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ display: "none" }}
                      aria-hidden="true"
                    />

                    <div className="col-12 mt-4">
                      <button
                        type="submit"
                        className="btn btn-outline-light btn-lg px-5 py-3 fw-bold"
                        disabled={isSubmitting}
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #fff",
                          backgroundColor: "transparent",
                          color: "#fff",
                          fontSize: "1rem",
                          fontWeight: "700",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {isSubmitting
                          ? t("newsletter.subscribing")
                          : t("newsletter.subscribeNow")}
                      </button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
